import {deleteLimitOrderApi } from "../components/constant/api";
import { myApi } from "./api";

export const limitOrderApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteLimitOrder: builder.mutation({
      query: (post) => ({
        url: deleteLimitOrderApi+"/"+post.id,
        method: "DELETE",
      }),
    }),
  }),
});

export const {useDeleteLimitOrderMutation}=limitOrderApi